module.exports = __webpack_public_path__ + "static/aouidef-c428ddacd178865e0277b3bb90a4b05c.png";